export const TYPE_LIST = 'list'
export const TYPE_PROPERTY = 'property'
export const TYPE_OBJECT = 'object'
export const TYPE_LABEL = 'label'
export const TYPE_VALUE = 'value'
export const TYPE_OPTION = 'option'
export const TYPE_OPTION_LIST = 'optionList'